import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, XCircle } from 'lucide-react';
export function SolutionDetails() {
  return <div className="bg-[#FFF5F0] py-20 px-4 sm:px-6 lg:px-8" data-id="element-167">
      <div className="max-w-4xl mx-auto" data-id="element-168">
        {/* Why Diets Fail */}
        <Section className="mb-20" data-id="element-169">
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden" data-id="element-170">
            <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-171">
              <div className="p-8 md:p-12 bg-rose-50" data-id="element-172">
                <h3 className="text-2xl font-serif text-rose-900 mb-6 flex items-center" data-id="element-173">
                  <XCircle className="mr-3 text-rose-500" data-id="element-174" />
                  La Estrategia Equivocada
                </h3>
                <ul className="space-y-4 text-rose-900/80" data-id="element-175">
                  <li className="flex items-start" data-id="element-176">
                    <span className="mr-2" data-id="element-177">•</span> Control de calorías
                  </li>
                  <li className="flex items-start" data-id="element-178">
                    <span className="mr-2" data-id="element-179">•</span> Prohibición estricta
                  </li>
                  <li className="flex items-start" data-id="element-180">
                    <span className="mr-2" data-id="element-181">•</span> Sentirte "buena" o "mala"
                  </li>
                  <li className="mt-4 font-semibold italic" data-id="element-182">
                    Resultado: Más estrés = Más antojos.
                  </li>
                </ul>
              </div>

              <div className="p-8 md:p-12 bg-white" data-id="element-183">
                <h3 className="text-2xl font-serif text-green-900 mb-6 flex items-center" data-id="element-184">
                  <CheckCircle2 className="mr-3 text-green-600" data-id="element-185" />
                  Lo que necesitas: Regulación
                </h3>
                <ul className="space-y-4 text-stone-600" data-id="element-186">
                  <li className="flex items-start" data-id="element-187">
                    <span className="mr-2" data-id="element-188">•</span> Devolverle la decisión a tu
                    cuerpo
                  </li>
                  <li className="flex items-start" data-id="element-189">
                    <span className="mr-2" data-id="element-190">•</span> Calma sin culpa
                  </li>
                  <li className="flex items-start" data-id="element-191">
                    <span className="mr-2" data-id="element-192">•</span> "Yo decido", no "Yo aguanto"
                  </li>
                  <li className="mt-4 font-semibold italic text-green-700" data-id="element-193">
                    Resultado: Paz mental y estabilidad.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </Section>

        {/* The Semaforo System */}
        <Section className="text-center max-w-3xl mx-auto" data-id="element-194">
          <span className="text-rose-500 font-bold tracking-wider text-sm uppercase mb-4 block" data-id="element-195">
            El Mecanismo
          </span>
          <h2 className="text-3xl md:text-4xl font-serif text-stone-900 mb-8" data-id="element-196">
            El Semáforo Hormonal
          </h2>
          <p className="text-lg text-stone-600 mb-12" data-id="element-197">
            No se trata de prohibir. Se trata de clasificar por efecto:{' '}
            <strong data-id="element-198">¿Esto me regula o me dispara?</strong>
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left" data-id="element-199">
            <div className="bg-green-50 p-6 rounded-2xl border border-green-100" data-id="element-200">
              <div className="w-4 h-4 rounded-full bg-green-500 mb-4" data-id="element-201"></div>
              <h4 className="font-bold text-green-900 mb-2" data-id="element-202">VERDE</h4>
              <p className="text-sm text-green-800" data-id="element-203">
                Baja la urgencia, sube la saciedad, estabiliza energía.
              </p>
            </div>

            <div className="bg-yellow-50 p-6 rounded-2xl border border-yellow-100" data-id="element-204">
              <div className="w-4 h-4 rounded-full bg-yellow-400 mb-4" data-id="element-205"></div>
              <h4 className="font-bold text-yellow-900 mb-2" data-id="element-206">AMARILLO</h4>
              <p className="text-sm text-yellow-800" data-id="element-207">
                Lo puedes disfrutar, pero con estructura inteligente.
              </p>
            </div>

            <div className="bg-red-50 p-6 rounded-2xl border border-red-100" data-id="element-208">
              <div className="w-4 h-4 rounded-full bg-red-500 mb-4" data-id="element-209"></div>
              <h4 className="font-bold text-red-900 mb-2" data-id="element-210">ROJO</h4>
              <p className="text-sm text-red-800" data-id="element-211">
                Te dispara el ciclo (urgencia → picoteo → culpa).
              </p>
            </div>
          </div>

          <p className="mt-8 text-stone-500 text-sm italic" data-id="element-212">
            *No es para que nunca comas rojo. Es para que no entres en modo "ya
            fue".
          </p>
        </Section>
      </div>
    </div>;
}